/**
 * Module-level signal for navigating to a specific control in the Interview Designer.
 *
 * Because React state and localStorage storage-events only propagate intra-tab
 * asynchronously, a module singleton is the simplest way to hand off a
 * navigation intent from the Command Palette to the IdProvider that may be
 * unmounted (navigating to /build/design) OR already mounted (switching
 * interview/step/control from the palette while staying on the same route).
 *
 * Usage:
 *   // writer (e.g. InterviewControlsPlugin)
 *   setPendingInterviewNavigation({ interviewId, stepId, controlId, ctrlPath });
 *
 *   // consumer (IdProvider) – reads AND clears in one call
 *   const nav = consumePendingInterviewNavigation();
 */

export interface PendingInterviewNavigation {
  interviewId: string;
  stepId: string;
  controlId: string;
  /** CtrlPath: array of [containerControlId, propertyName] pairs leading to the
   *  array that contains the target control. Empty for root-level controls. */
  ctrlPath: Array<[string, string]>;
}

let _pending: PendingInterviewNavigation | null = null;

export const setPendingInterviewNavigation = (nav: PendingInterviewNavigation): void => {
  _pending = nav;
};

export const consumePendingInterviewNavigation = (): PendingInterviewNavigation | null => {
  const value = _pending;
  _pending = null;
  return value;
};
